import { Card } from "@/src/components/cards";
import { DocumentTemplate, Reference } from "@/src/data/allTypes";
import { jsonAbstract, uid } from "@/src/utils/utils";
import { openTemplateEditor } from "../../documents/documentsHook";
import apiFetch from "@/src/utils/apiFetch";
import {
  closeDialog,
  openConfirmDialog,
  openDrawer,
} from "@/src/components/dialogs";
import { openDocumentTemplateForm } from "./documentTemplateForm";
import { ReferenceForm } from "./referenceForm";

export function AdminDocumentTemplateCard({
  documentTemplate,
  onDelete,
  onChange,
}: {
  documentTemplate: DocumentTemplate;
  onDelete?: (e: any) => any;
  onChange: (newValue: DocumentTemplate | null | undefined) => void;
}) {
  async function openFormulaireDialog(formulaire: Reference) {
    await openDrawer({
      id: "formulaireDialog",
      title: "Formulaire",

      content: (
        <ReferenceForm
          current={formulaire}
          categories={["formulaire"]}
          onChange={(newValue) => {
            formulaire = newValue;
          }}
        />
      ),
      onConfirm: async () => {
        let inserted = await apiFetch("references", "addOne", {
          reference: formulaire,
        });
        onChange(inserted as DocumentTemplate);
      },
    });
  }

  return (
    <Card
      key={uid()}
      color="blue"
      title={documentTemplate.name}
      onClick={async () => {
        await openTemplateEditor({
          template: documentTemplate,
          onSave: async (newValue) => {
            documentTemplate = newValue;
            let result = await apiFetch("documentTemplates", "addOne", {
              documentTemplate,
            });
            if (!result) return;
            documentTemplate = result;
            closeDialog("documentEditorDialog");
            onChange(result);
          },
        });
      }}
      onDelete={
        onDelete != null
          ? onDelete
          : async () => {
              await openConfirmDialog({
                id: "deleteDocumentTemplate",
                content: "Voulez-vous vraiment supprimer ce modèle ?",
                onConfirm: async () => {
                  await apiFetch("general", "deleteAny", {
                    id: documentTemplate.id,
                    table: "documentTemplates",
                  });
                  onChange(null);
                },
              });
            }
      }
      onEdit={async () => {
        await openDocumentTemplateForm({
          current: jsonAbstract(documentTemplate),
          onSave: (newValue) => {
            documentTemplate = newValue;
            onChange(newValue);
          },
        });
      }}
    >
      <div className="c1 gap5 mtop5">
        {documentTemplate.reference && (
          <div
            className="card"
            onClick={(e) => {
              e.stopPropagation();
              if (!documentTemplate.reference) return;
              openFormulaireDialog(documentTemplate.reference);
            }}
          >
            Formulaire: {documentTemplate.reference.name}
          </div>
        )}
      </div>
      {/* <Copyable str={documentTemplate.id || ""}></Copyable> */}
    </Card>
  );
}
